<template>
  <div class="summary-box"  :class="{'summar-box-2':isUi2}">
    <div class="m-disabled-box" v-if="!enablePlaceOrder"></div>
    <b-container>
      <b-row  v-if="!isUi2">
        <b-col class="summary-head"><h4>Payment Information</h4></b-col>
      </b-row>
      <b-row>

      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Email(*): </b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.Email"
                   @input.native="updateContact('Email', $event)"
                   data-test = "summary-pay-email"
                   size="sm"></b-input>
          <m-error-text :val="orderContact.Email" :immediate="showError" :rules="['require', 'email']"/>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Order Name(*):</b-col>
        <b-col lg="7">
          <b-input :value ="order.OrderDesc"
                   @input.native="updateOrderDesc"
                   data-test = "summary-pay-orderName"
                   size="sm"></b-input>
          <m-error-text :val="order.OrderDesc" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col lg="5" class="item-title">Company Name(*):</b-col>
        <b-col lg="7">
          <b-input :value = "orderContact.Company"
                   data-test = "summary-pay-company"
                   size="sm" disabled></b-input>
          <m-error-text :val="orderContact.Company" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row>
      <div v-if ="isCreditCard">
        <!--TODO@PONY need check-->
        <b-row class="item">
          <b-col lg="5" class="item-title">Card Type(*): </b-col>
          <b-col lg="7">
            <b-form-select v-model="orderPayment.CardType" :options="cardType"  data-test = "summary-pay-cardType"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Name On Card(*): </b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.HolderName"
                     @input.native="updatePayment('HolderName', $event)"
                     data-test = "summary-pay-holderName"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.HolderName" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Card Number(*): </b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.Number"
                     @input.native="updatePayment('Number', $event)"
                     data-test = "summary-pay-cardNumber"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.Number" :immediate="showError" :rules="['require', 'creditCard']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Security Code(*): </b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.SecurityCode"
                     @input.native="updatePayment('SecurityCode', $event)"
                     data-test = "summary-pay-securityCode"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.SecurityCode" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Card Expiration(*): </b-col>
          <b-col lg="3">
            <b-form-select v-model="orderPayment.ExpiredMonth" :options="expiredMonth"  data-test = "summary-pay-expiredMonth"/>
          </b-col>
          <b-col lg="4">
            <b-form-select v-model="orderPayment.ExpiredYear" :options="expiredYear"  data-test = "summary-pay-expiredYear"/>
          </b-col>

        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Country(*):</b-col>
          <b-col lg="7">
            <b-form-radio-group v-model ="orderPayment.CountryCode" data-test = "summary-pay-country">
              <b-form-radio value="US">USA</b-form-radio>
              <b-form-radio value="CA">Canada</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Address(*):</b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.AddressLine"
                     @input.native="updatePayment('AddressLine', $event)"
                     data-test = "summary-pay-address"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.AddressLine" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">City(*):</b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.City"
                     @input.native="updatePayment('City', $event)"
                     data-test = "summary-pay-city"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.City" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">State(*):</b-col>
          <b-col lg="7">
              <b-form-select v-model="orderPayment.State" data-test = "summary-pay-state">
                <option v-for = "item in $store.state.geo.states"
                        :value="item.code">
                  {{item.code}}
                </option>
              </b-form-select>

            <m-error-text :val="orderPayment.State" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row>
        <b-row class="item">
          <b-col lg="5" class="item-title">Zip(*):</b-col>
          <b-col lg="7">
            <b-input :value = "orderPayment.Zipcode"
                     @input.native="updatePayment('Zipcode', $event)"
                     data-test = "summary-pay-zip"
                     size="sm"></b-input>
            <m-error-text :val="orderPayment.Zipcode" :immediate="showError" :rules="['require', 'zip']"/>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>

</template>

<script>
  import MErrorText from '@/components/common/MerrorText'
  export default {
    components: {
      MErrorText
    },
    props: {
      isUi2: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        cardType: [
          {
            value: 10,
            text: 'VISA'
          },
          {
            value: 20,
            text: 'MasterCard'
          },
          {
            value: 30,
            text: 'American Express'
          },
          {
            value: 40,
            text: 'Discover'
          }
        ]
      }
    },
    watch: {},
    created () {

    },
    methods: {
      updateContact (key, e) {
        this.$store.commit('order/updateContactInformation', {
          key: key,
          val: e.target.value
        })
      },
      updatePayment (key, e) {
        this.$store.commit('order/updatePaymentInformation', {
          key: key,
          val: e.target.value
        })
      },
      updateOrderDesc (e) {
        // this.$store.commit('order/saveKey', ['OrderDesc', e.target.value])
        this.$store.commit('order/updateContactInformation', {
          key: 'OrderName',
          val: e.target.value
        })
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      orderContact () {
        return this.$store.state.order.OrderContactInformation || {}
      },
      orderPayment () {
        return this.$store.state.order.OrderPaymentInformation || {}
      },
      showError () {
        return this.$store.getters['summary/showError']
      },
      isCreditCard () {
        return this.$store.getters['order/isCreditCard']
      },
      expiredYear () {
        let result = []
        let now = new Date()
        let year = now.getFullYear()
        for (let i = 0; i <= 10; i++) {
          result.push(year + i)
        }
        return result
      },
      expiredMonth () {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      },
      enablePlaceOrder () {
        return this.$store.getters['site/enablePlaceOrder']
      }
    }
  }
</script>

<style scoped lang="scss">
.item {
  padding-top: 8px;
  font-size: 13px;
}
.item-title {
  padding-right: 0;
  margin-right: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/summary/MPayment.vue